import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/components/Home'
import Dashboard from '@/components/Dashboard'
import Countdown from '@/components/Countdown'
import Login from '@/components/user/Login'
import Profile from '@/components/user/Profile'
// import Support from '@/components/Support'
import Confirmation from '@/components/Confirmation'
import Application from '@/components/application/Application'
// import Welcome from '@/components/application/Welcome'
import StepOne from '@/components/application/StepOne'
import StepTwo from '@/components/application/StepTwo'
import StepThree from '@/components/application/StepThree'
import StepFour from '@/components/application/StepFour'
import StepFive from '../components/application/StepFive.vue'
import ThankYou from '@/components/application/ThankYou'
import MainAdmin from '@/components/admin/MainAdmin'
import Search from '@/components/admin/Search'
import SearchAppStatus from '@/components/admin/SearchAppStatus'
import ViewApp from '@/components/admin/ViewApp'
import JuryAssignments from '@/components/admin/JuryAssignments'
import Jury from '@/components/jury/Jury'
import ListJuryApplications from '@/components/jury/ListJuryApplications'
import Schedule from '@/components/schedule/Schedule'
import SvSchedule from '@/components/schedule/SvSchedule'
import TlSchedule from '@/components/schedule/TlSchedule'
import Shift from '@/components/schedule/Shift'
import CreateShiftSwapRequest from '@/components/schedule/CreateShiftSwapRequest'
import ListShiftSwapRequests from '@/components/schedule/ListShiftSwapRequests'
import store from '@/store'
import moment from 'moment'
import ViewCompleteApplication from '../components/application/ViewCompleteApplication.vue'

const jwtDecode = require('jwt-decode')

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home,
      beforeEnter: checkNotAuth
    },
    {
      path: '/dashboard',
      name: 'Dashboard',
      component: Dashboard,
      beforeEnter: checkAuth
    },
    {
      path: '/countdown',
      name: 'Countdown',
      component: Countdown,
      beforeEnter: checkNotAuth
    },
    {
      path: '/login',
      name: 'Login',
      component: Login,
      beforeEnter: checkNotAuth
    },
    {
      path: '/forgot-password',
      redirect: to => {
        console.log(to)
        if (to.query.token === undefined) {
          store.commit('error', { message: 'Invalid password reset token' })
          return { name: 'Home' }
        }
        let token = to.query.token
        console.log(token)
        let decoded = jwtDecode(token)
        let exp = moment.unix(decoded.exp)
        if (moment().isAfter(exp)) {
          store.commit('error', { message: 'Token has expired' })
          return '/'
        }
        if (decoded.token_use !== 'password-reset') {
          store.commit('error', { message: 'Token is not valid' })
          return '/'
        }
        store.commit('user/setForgottenPasswordToken', token)
        return '/'
      }
    },
    {
      path: '/profile',
      name: 'Profile',
      component: Profile,
      beforeEnter: checkAuth
    },
    // {
    //   path: '/support',
    //   name: 'Support',
    //   component: Support,
    //   beforeEnter: checkAuth
    // },
    {
      path: '/confirmation',
      name: 'Confirmation',
      component: Confirmation
      // beforeEnter: checkAuth
    },
    {
      path: '/application',
      name: 'Application',
      component: Application,
      beforeEnter: checkAuth,
      children: [
        // {
        //   path: '0',
        //   name: 'welcome',
        //   component: Welcome
        // },
        {
          path: '1',
          name: 'stepOne',
          component: StepOne
        },
        {
          path: '2',
          name: 'stepTwo',
          component: StepTwo
        },
        {
          path: '3',
          name: 'stepThree',
          component: StepThree
        },
        {
          path: '4',
          name: 'stepFour',
          component: StepFour
        },
        {
          path: 'submit',
          name: 'stepFive',
          component: StepFive
        },
        {
          path: 'thank-you',
          name: 'thankYou',
          component: ThankYou
        },
        {
          path: 'view',
          name: 'viewApplication',
          component: ViewCompleteApplication
        }
      ]
    },
    {
      path: '/admin',
      name: 'Admin',
      component: MainAdmin,
      beforeEnter: checkAuth,
      children: [
        {
          path: 'application/search',
          name: 'SearchApps',
          component: Search
        },
        {
          path: 'application/search-status',
          name: 'SearchAppsByStatus',
          component: SearchAppStatus
        },
        {
          path: 'application/:username',
          name: 'ViewApp',
          component: ViewApp,
          props: true
        },
        {
          path: 'jury/assignments',
          name: 'JuryAssignments',
          component: JuryAssignments
        }
      ]
    },
    {
      path: '/jury',
      name: 'Jury',
      component: Jury,
      beforeEnter: checkAuth,
      children: [
        {
          path: 'view',
          name: 'ListJuryApplications',
          component: ListJuryApplications
        }
      ]
    },
    {
      path: '/schedule',
      name: 'Schedule',
      component: Schedule,
      beforeEnter: checkAuth,
      children: [
        {
          path: 'sv',
          name: 'SvSchedule',
          component: SvSchedule
        },
        {
          path: 'tl',
          name: 'TlSchedule',
          component: TlSchedule
        },
        {
          path: 'shift/:id',
          name: 'Shift',
          component: Shift,
          props: true
        },
        {
          path: 'swap/list',
          name: 'ShiftSwapRequests',
          component: ListShiftSwapRequests
        },
        {
          path: 'swap/:id/create',
          name: 'CreateShiftSwapRequest',
          component: CreateShiftSwapRequest,
          props: true
        }
      ]
    }
  ],
  scrollBehavior () {
    return { x: 0, y: 0 }
  }
})

function checkAuth (to, from, next) {
  // Clear any error or messages when navigating to another page
  store.commit('clearError')
  store.commit('clearMessage')
  let token = localStorage.getItem('accessToken')
  if (moment(store.state.applicationLaunchDate).diff(moment()) > 0 && to.path !== '/') {
    console.log('not yet')
    store.dispatch('user/logout')
    next('/') // it's not time for applications yet
  } else if (token != null) {
    let decoded = jwtDecode(token)
    let exp = moment.unix(decoded.exp)
    if (moment().isAfter(exp)) {
      store.dispatch('user/logout')
      next('/')
    } else {
      if (store.state.user.session.accessToken == null) {
        store.commit('user/setSession', token)
      }
      if (!store.state.user.loadedAttributes) {
        store.dispatch('user/loadAttributes').then(() => {
          next()  // they are authorized
        }).catch(err => {
          // Something went wrong with loading the user's attributes
          console.log(err)
          next()
        })
      } else {
        next()
      }
    }
  } else {
    next('/')
  }
}

function checkNotAuth (to, from, next) {
  // Clear any error or messages when navigating to another page
  store.commit('clearError')
  store.commit('clearMessage')
  let token = localStorage.getItem('accessToken')

  if (moment(store.state.applicationLaunchDate).diff(moment()) > 0 && to.path !== '/') {
    next('/')
  } else if (token != null) {
    let decoded = jwtDecode(token)
    let exp = moment.unix(decoded.exp)
    if (moment().isAfter(exp)) {
      store.dispatch('user/logout')
      next()
    } else {
      next('/dashboard')  // they are authorized, so redirect to dashboard
    }
  } else {
    next()
  }
}



// WEBPACK FOOTER //
// ./src/router/index.js